<template>
  <div>
    <el-row style="margin: 24px 0 10px 0;" class="titleData">
      <span>客户：{{ titleData.TC_NAME }}</span>
      <span>项目点：{{ titleData.PROJECT_NAME }}</span>
    </el-row>
    <el-row>
      <el-form :model="searchForm" ref="searchForm" :inline="true" size="medium">
        <el-form-item label="分类：">
          <el-select v-model="searchForm.CATALOG_ID_LIST" clearable filterable multiple>
            <el-option v-for="item in catalogList" :key="item.ID" :label="item.CATALOG_NAME" :value="item.ID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产品名称：">
          <el-input v-model="searchForm.PRODUCT_NAME" clearable @keyup.enter.native="handleSearch"></el-input>
        </el-form-item>
        <el-form-item label="日期范围：">
          <el-date-picker v-model="searchForm.DATE" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" value-format="yyyy-MM-dd" :clearable="false">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <tooltip-button :disabled="dateRangeSelected" tipContent="请先选择日期范围" buttonType="primary"
            buttonText="筛选" @click="handleSearch">
          </tooltip-button>
          <el-tooltip class="item" effect="dark" content="请选择日期范围" placement="bottom" :disabled="dateRangeSelected">
            <div style="display: inline-block;">
              <download-excel style="display: inline;" :data="exportData" :fields="exportFields"
                :name="`${titleData.TC_NAME}-${titleData.PROJECT_NAME}-销售报表详情-${searchForm.DATE[0]}~${searchForm.DATE[1]}.xls`"
                :before-finish="endDownload" :before-generate="exportExcel">
                <el-button type="primary" :disabled="!dateRangeSelected" v-preventReClick plain>
                  导出
                </el-button>
              </download-excel>
            </div>
          </el-tooltip>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" max-height="520" stripe border>
          <el-table-column label="序号" type="index" width="50px"></el-table-column>
          <el-table-column label="分类" prop="FC_NAME" min-width="100px"></el-table-column>
          <el-table-column label="品牌" prop="BRAND" min-width="100px"></el-table-column>
          <el-table-column label="品名" prop="NAME" min-width="100px"></el-table-column>
          <el-table-column label="规格" prop="SPECIFICATION" min-width="100px"></el-table-column>
          <el-table-column label="单位" prop="TYPE_UNIT" min-width="100px"></el-table-column>
          <el-table-column label="数量" prop="COUNT" min-width="100px"></el-table-column>
          <el-table-column label="均价" prop="PRICE" min-width="100px"></el-table-column>
          <el-table-column label="销售金额" prop="TOTAL_FEE" min-width="100px"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <div class="pagination_box" style="text-align: right">
        <el-pagination @current-change="queryData(currentPage - 1)" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount">
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>
<script>
import http from '@/assets/common/http';
import { getClassFun } from '@/assets/api/skuManage';

export default {
  data() {
    return {
      searchForm: {
        DATE: JSON.parse(sessionStorage.getItem('dateRange')),
      },
      tableData: [],
      totalCount: 0,
      currentPage: 1,
      pageSize: Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10,
      titleData: JSON.parse(sessionStorage.getItem('salesStatementsDetailTitle')) || {
        TC_ID: null,
        TC_NAME: null,
        PROJECT_ID: null,
        PRODUCT_NAME: null,
      },
      catalogList: [],
      exportData: [],
      exportFields: {
        序号: 'index',
        分类: 'FC_NAME',
        品牌: 'BRAND',
        品名: 'NAME',
        规格: 'SPECIFICATION',
        单位: 'TYPE_UNIT',
        数量: 'COUNT',
        均价: 'PRICE',
        销售金额: 'TOTAL_FEE',
      },
    };
  },
  computed: {
    tcId() {
      return this.titleData.TC_ID;
    },
    projectId() {
      return this.titleData.PROJECT_ID;
    },
    dateRangeSelected() {
      return Boolean(this.searchForm.DATE && this.searchForm.DATE[0]);
    },
  },
  mounted() {
    this.queryCatalog();
    if (this.searchForm.DATE[0]) {
      this.handleSearch();
    }
  },
  methods: {
    // 导出
    async exportExcel() {
      const params = {
        SERVICE_ID: '15069',
        OTYPE: 12,
        GYS_ID: sessionStorage.getItem('tcId'),
        TC_ID: this.tcId,
        PROJECT_ID: this.projectId,
        START_DAY: this.searchForm.DATE[0],
        END_DAY: this.searchForm.DATE[1],
      };
      if (this.searchForm.CATALOG_ID_LIST && this.searchForm.CATALOG_ID_LIST[0]) {
        params.FC_CODE_LIST = [...this.searchForm.CATALOG_ID_LIST];
      }
      if (this.searchForm.PRODUCT_NAME) {
        params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      }
      await http.post(params).then((res) => {
        if (res[0].list.length == 0) {
          this.$message.show({ text: '暂无数据', type: 'warning' });
        } else {
          const list = res[0].list.map((item, index) => ({
            ...item,
            index: index + 1,
          }));
          let count = 0;
          let totalFee = 0;
          list.forEach((item) => {
            count += Number(item.COUNT);
            totalFee += Number(item.TOTAL_FEE);
          });
          const lastRow = {
            index: '合计',
            COUNT: `&nbsp;${count.toFixed(2)}`,
            TOTAL_FEE: `&nbsp;${totalFee.toFixed(2)}`,
          };
          list.push(lastRow);
          this.exportData = list;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 筛选
    handleSearch() {
      this.currentPage = 1;
      this.queryData();
    },
    // 获取界面数据
    queryData(PAGEINDEX) {
      const params = {
        SERVICE_ID: '15069',
        OTYPE: 11,
        GYS_ID: sessionStorage.getItem('tcId'),
        TC_ID: this.tcId,
        PROJECT_ID: this.projectId,
        START_DAY: this.searchForm.DATE[0],
        END_DAY: this.searchForm.DATE[1],
        PAGEINDEX,
        PAGESIZE: this.pageSize,
      };
      if (this.searchForm.CATALOG_ID_LIST && this.searchForm.CATALOG_ID_LIST[0]) {
        params.FC_CODE_LIST = [...this.searchForm.CATALOG_ID_LIST];
      }
      if (this.searchForm.PRODUCT_NAME) {
        params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      }
      http.post(params).then((res) => {
        this.tableData = res[0].list;
        this.totalCount = res[0].TOTAL_COUNT;
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    queryCatalog() {
      getClassFun().then((result) => {
        if (result.length !== 0) {
          this.catalogList = result;
        } else {
          this.catalogList = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    endDownload() {
      this.exportData = [];
    },
  },
};
</script>
<style scoped>
.titleData span {
  display: inline-block;
  margin-right: 10px;
  font-weight: bold;
}

.el-tooltip {
  margin-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/tableManage/salesStatementsDetail.vue